import { brandController } from '@/apis/core';

export const getBrandNameAutocompleteOptions = async (
  value: string
): Promise<string[]> => {
  const response = await brandController.getBrandSuggestions({
    prefix: value,
    limit: 20,
  });
  return response?.map((suggestion) => suggestion.brandName) || [];
};
